import { useEffect, useState } from "react";
import { getCourseCategory ,getRole} from "../services/CourseService";
import { getCourse } from "../services/QuizService";
import { getLanguages, getModels, getTopics ,getModelsById, getTopicById} from "../services/CourseFileService";
import { getQuiz } from "../services/QuestionService";
import { getModuleFromServer } from "../services/ModuleService";

const sortOptions = (options) => options.sort((a, b) => a.label.localeCompare(b.label));

export const useCategoryOptions = () => {
  const [categoryOptions, setCategoryOptions] = useState([]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const options = await getCourseCategory();
        setCategoryOptions(options);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };
    fetchCategories();
  }, []);

  return categoryOptions;
};

export const useQuizOptions = () => {
  const [quizOptions, setQuizOptions] = useState([]);
  useEffect(() => {
    const fetchQuiz = async () => {
      try {
        const options = await getQuiz();
        setQuizOptions(sortOptions(options));
      } catch (error) {
        console.error("Failed to fetch Quizzes:", error);
      }
    };
    fetchQuiz();
  }, []);

  return quizOptions;
};

export const useCourseOptions = () => {
  const [courseOptions, setCourseOptions] = useState([]);
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const options = await getCourse();
        setCourseOptions(sortOptions(options));
      } catch (error) {
        console.error("Failed to fetch Courses:", error);
      }
    };
    fetchCourses();
  }, []);
  return courseOptions;
};

export const useLanguageOptions = () => {
  const [languageOptions, setLanguageOptions] = useState([]);
  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const options = await getLanguages();
        setLanguageOptions(sortOptions(options));
      } catch (error) {
        console.error("Failed to fetch Languages:", error);
      }
    };
    fetchLanguages();
  }, []);

  return languageOptions;
};

export const useModuleOptions = () => {
  const [moduleOptions, setModuleOptions] = useState([]);
  useEffect(() => {
    const fetchModules = async () => {
      try {
        const options = await getModels();
        setModuleOptions(sortOptions(options)); 
      } catch (error) {
        console.error("Failed to fetch Modules:", error);
      }
    };
    fetchModules();
  }, []);

  return moduleOptions;
};

export const useTopicOptions = () => {
  const [topicOptions, setTopicOptions] = useState([]);
  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const options = await getTopics();
        setTopicOptions(sortOptions(options)); 
      } catch (error) {
        console.error("Failed to fetch Topics:", error);
      }
    };
    fetchTopics();
  }, []);

  return topicOptions;
};

export const useRoleOptions = () => {
  const [roleOptions, setRoleOptions] = useState([]);
  useEffect(() => {
    const fetchRole = async () => {
      try {
        const options = await getRole();
        setRoleOptions(sortOptions(options));
      } catch (error) {
        console.error("Failed to fetch Roles:", error);
      }
    };
    fetchRole();
  }, []);

  return roleOptions;
};

export const useModuleByIdOptions = (courseId) => {
  const [moduleOptions, setModuleOptions] = useState([]);
  useEffect(() => {
    const fetchModules = async () => {
      if (!courseId) return;
      try {
        const options = await getModelsById(courseId);
        setModuleOptions(sortOptions(options));
      } catch (error) {
        console.error("Failed to fetch Modules:", error);
        setModuleOptions([]);
      }
    };
    fetchModules();
  }, [courseId]);

  return moduleOptions;
};

export const useTopicByIdOptions = (moduleId) => {
  const [topicOptions, setTopicOptions] = useState([]);
  useEffect(() => {
    const fetchTopics = async () => {
      if (!moduleId) return; 
      try {
        const options = await getTopicById(moduleId);
        setTopicOptions(sortOptions(options));
      } catch (error) {
        console.error("Failed to fetch Topics:", error);
        setTopicOptions([]);
      }
    };
    fetchTopics();
  }, [moduleId]);

  return topicOptions;
};

export const useAllModules = () => {
  const [modules, setModules] = useState([]);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await getModuleFromServer();
        const formattedModules = response.data.map((module) => ({
          label: module.title,
          value: module.id,
        }));
        setModules(formattedModules);
      } catch (error) {
        console.error("Error loading modules:", error);
      }
    };
    fetchModules();
  }, []);

  return modules;
};